import React from 'react';
import { ChevronDown } from 'lucide-react';

const MemberFilter = ({ members, selectedMember, onSelect }) => {
    return (
        <div className="relative w-full mb-3">
            <select
                value={selectedMember}
                onChange={(e) => onSelect(e.target.value)}
                className="w-full appearance-none bg-white border border-gray-200 rounded-xl px-4 py-3 pr-10 text-gray-800 font-medium text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300 shadow-sm cursor-pointer"
            >
                {members.map((m) => (
                    <option key={m.id} value={m.id}>
                        {m.name}
                    </option>
                ))}
            </select>
            <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
        </div>
    );
};

export default MemberFilter;
